import type { Resource } from '../../';
export const product_group_kids: Resource = {"default":"Kids'"};
